import { Button, Switch, TextInput } from '@resurs/midas-react'
import React from 'react'
import { midas } from '@resurs/midas'
import { useLocaleState } from '@merchant-portal/merchant-portal-base'
import { format } from '../../../../models/format'
import { getText } from '../../../../internal/TextLabels'
import { naturalGovIdPlaceholder } from '../../../../util/governmentIdUtils'

const PushFormToCustomer = ({
  header,
  description,
  sendByTextMessage,
  toggleTextMessage,
  openWithQR,
  toggleQR,
  mobileNumber,
  onChangeMobileNumber,
  formHasCoApplicant,
  toggleCoApplicant,
  coApplicantCheck,
  coApplicant,
  governmentId,
  onChangeGovernmentId,
  getCoApplicantInfo,
  isValid,
  additionalValidation,
  disabled,
}) => {
  const { country, language } = useLocaleState()

  return (
    <>
      {header && <h5>{header}</h5>}
      {coApplicant && (
        <div>
          <TextInput
            format={format.governmentId[country]}
            placeholder={naturalGovIdPlaceholder(country, language)}
            value={governmentId || ''}
            onChange={onChangeGovernmentId}
            label={getText('payApply.pushToCustomer.coApplicantGovernmentId')}
            style={{ width: '50%', flexGrow: 1 }}
            required={format.governmentId[country].error}
            isValid={isValid}
            additionalValidation={additionalValidation}
          />
          <Button
            label
            size="small"
            disabled={disabled}
            onClick={getCoApplicantInfo}
          >
            {getText('payApply.paymentMethodForm.getCoappInfoBtn')}
          </Button>
        </div>
      )}
      {description && (
        <label className={midas.formLabel} style={{ marginTop: '3rem' }}>
          {description}
        </label>
      )}
      <Switch
        id={coApplicant ? 'coApplicantOpenWithQRId' : 'openWithQRId'}
        text={getText('payApply.pushToCustomer.openWithQR')}
        checked={openWithQR}
        onChange={toggleQR}
      />
      <div
        style={{
          display: 'flex',
          width: '100%',
          alignItems: 'center',
        }}
      >
        <Switch
          id={
            coApplicant ? 'coApplicantSendTextMessageId' : 'sendTextMessageId'
          }
          text={getText('payApply.pushToCustomer.sendWithSMS')}
          checked={sendByTextMessage}
          onChange={toggleTextMessage}
        />
        <TextInput
          format={format.mobilePhone}
          value={mobileNumber || ''}
          onChange={onChangeMobileNumber}
          style={{ width: '100%', flexGrow: 1, margin: '0' }}
          required={sendByTextMessage && getText('default.form.required')}
          disabled={!sendByTextMessage}
        />
      </div>
      {formHasCoApplicant && (
        <label
          style={{
            display: 'flex',
            alignItems: 'center',
            columnGap: '1rem',
            marginTop: '2rem',
          }}
        >
          <input
            type="checkbox"
            checked={coApplicantCheck || false}
            onChange={toggleCoApplicant}
          />
          {getText('payApply.pushToCustomer.coApplicantDescription')}
        </label>
      )}
    </>
  )
}

export default PushFormToCustomer
